import { useTranslations } from '@vocab/react';
import { Box, IconAI, Inline, Text } from 'braid-design-system';

import { CareerFeedBetaBadge } from '../CareerFeedBetaBadge';

import translations from './.vocab';

import * as styles from './CareerFeedAIAssistantFAB.css';

const ButtonLoader = () => (
  <Box aria-hidden component="span" display="inlineBlock" color="dark">
    <Box component="span" className={styles.loadingDot}>
      .
    </Box>
    <Box component="span" className={styles.loadingDot}>
      .
    </Box>
    <Box component="span" className={styles.loadingDot}>
      .
    </Box>
  </Box>
);

export const CareerFeedAIAssistantFAB = ({
  onButtonClick,
  isButtonLoading,
}: {
  onButtonClick: () => void;
  isButtonLoading: boolean;
}) => {
  const { t } = useTranslations(translations);
  return (
    <Box
      position="fixed"
      display="flex"
      gap="large"
      bottom={0}
      left={0}
      width="full"
      justifyContent="center"
      marginBottom="small"
      zIndex={1}
    >
      <Box className={styles.boxBorder}>
        <Box
          className={styles.fab}
          background="customDark"
          paddingX="xsmall"
          paddingY="small"
          role="button"
          onClick={onButtonClick}
        >
          <Inline space="xsmall" alignY="center" align="center">
            <IconAI />
            {isButtonLoading ? (
              <Text weight="medium">
                {t('Loading')}
                <ButtonLoader />
              </Text>
            ) : (
              <Text weight="medium">{t('Want better job matches?')}</Text>
            )}
            <CareerFeedBetaBadge tone="promote" />
          </Inline>
        </Box>
      </Box>
    </Box>
  );
};
